import fallbackVideo from '../assets/WhatsApp Video 2026-04-08 at 3.24.55 PM.mp4';
import curseVideo from '../assets/Curse of the Nile/Curse of the Nile 24.MOV';
import midnightVideo from '../assets/Midnight Manor/Vampire Hotel 24.mov';
import locandaVideo from '../assets/Locanda/Locanda Happiness 24.MP4';

/**
 * DeadZone + SkyWar source files are >25 MiB — Cloudflare Pages rejects them in the bundle.
 * Set public URLs in Cloudflare Pages → Settings → Environment variables (or .env.local for dev).
 */
const remoteMp4 = {
  deadzone: process.env.REACT_APP_VIDEO_DEADZONE?.trim() || '',
  skywar: process.env.REACT_APP_VIDEO_SKYWAR?.trim() || '',
};

/** Per-project hero video in gallery; missing / no URL uses fallback */
const projectVideos = {
  'curse-of-the-nile': curseVideo,
  deadzone: remoteMp4.deadzone || fallbackVideo,
  skywar: remoteMp4.skywar || fallbackVideo,
  'midnight-manor': midnightVideo,
  locanda: locandaVideo,
};

/** Known container format per slug (bundled URLs lose reliable extension checks) */
const projectVideoKind = {
  'curse-of-the-nile': 'quicktime',
  deadzone: 'mp4',
  skywar: 'mp4',
  'midnight-manor': 'quicktime',
  locanda: 'mp4',
};

export function getProjectVideo(slug) {
  return projectVideos[slug] ?? fallbackVideo;
}

/** Video for gallery modal only — no generic fallback when slug is unknown */
export function getProjectGalleryVideo(slug) {
  if (slug == null || slug === '') return null;
  if (!Object.prototype.hasOwnProperty.call(projectVideos, slug)) return null;
  const src = projectVideos[slug];
  if (src === '' || src == null) return null;
  return src;
}

export function isQuickTimeProjectVideo(slug) {
  return projectVideoKind[slug] === 'quicktime';
}

export function getVideoMimeType(src) {
  const lower = String(src).toLowerCase();
  if (lower.includes('.mov')) return 'video/quicktime';
  if (lower.includes('.webm')) return 'video/webm';
  if (lower.startsWith('http://') || lower.startsWith('https://')) return 'video/mp4';
  return 'video/mp4';
}
